<button
  type="button"
  class="text-secondary-400 dark:text-secondary-300 flex items-center gap-3 w-full focus:outline-none focus:ring-4 focus:ring-blue-300 font-normal text-base rounded-xl px-5 text-center dark:hover:bg-primary-950 dark:focus:ring-blue-800"
  (click)="buttonClicked()">
  <svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.42188 1.40625L2.82812 6L7.42188 10.5938L6.01562 12L0.015625 6L6.01562 0L7.42188 1.40625Z" fill="#9CA3AF" />
  </svg>
  <p class="text-secondary-400 dark:text-secondary-300 text-base">Back</p>
</button>
